// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"1739b9b4","455":"08b66c04","977":"88d5be77"}[chunkId] + ".chunk.js";
};